module.exports = __webpack_public_path__ + "static/media/Bob-Hires-sepia-cropped-small.05aac68c.png";